{
  "App": {
    "Title": "Cenorion"
  },
  "Nav": {
    "Primary": "Main navigation",
    "Dashboard": "Dashboard",
    "Devices": "Devices",
    "Users": "Users",
    "PlansContracts": "Plans & Contracts",
    "AppCustomization": "App customization",
    "Profile": "Profile"
  },
  "Search": {
    "Placeholder": "Search IMEI, device, consumer.."
  },
  "Onboarding": {
    "Label": "Product tour",
    "Progress": "{{current}}/{{total}}",
    "Actions": {
      "Continue": "Continue",
      "Done": "Done",
      "Dismiss": "Dismiss tour"
    },
    "Steps": {
      "Dashboard": {
        "Title": "Dashboard",
        "Body": "Your starting point. See what needs your attention, how your program is trending, and a quick snapshot of every device's state — enrolled, active, locked, or released."
      },
      "Devices": {
        "Title": "Devices",
        "Body": "Every device lives here. Browse the registry by IMEI, dig into a device's summary, connectivity, security and history, work through the provisioning queue, and register new devices when they arrive."
      },
      "PlansContracts": {
        "Title": "Services & Workflows",
        "Body": "Where you set the rules. Build and manage the plans your customers are on, and the workflows that decide what happens at each stage — reminders, lock steps, escalations. One workflow can power many plans."
      },
      "AppCustomization": {
        "Title": "Configuration",
        "Body": "Platform-wide settings. Message templates, quiet hours and calendars, users and roles, branding, device controls, and the audit log. If it applies across the whole portal, it's in here."
      },
      "Search": {
        "Title": "Search",
        "Body": "Jump to anything fast. Search by IMEI, plan or workflow name — results group by type so you can go straight to the record you need."
      },
      "Profile": {
        "Title": "Your avatar",
        "Body": "Everything about you — profile, password, MFA, sessions. You can also replay this tour anytime, or reach support from here."
      }
    }
  },
  "Theme": {
    "Label": "Theme",
    "Light": "Light",
    "Dark": "Dark"
  },
  "Common": {
    "Actions": {
      "SignIn": "Sign in",
      "SignOut": "Sign out",
      "Edit": "Edit",
      "Save": "Save",
      "Cancel": "Cancel",
      "Close": "Close"
    }
  },
  "Dev": {
    "ToggleDirection": "Toggle direction"
  },
  "Dashboard": {
    "Title": "Dashboard",
    "Greeting": "Welcome back, {{name}}!",
    "Subline": "{{tenant}} | Role · {{role}}",
    "Role": {
      "OperationsManager": "Operations Manager"
    },
    "Kpi": {
      "TotalDevices": "Total devices",
      "Enrolled": "Enrolled",
      "Active": "Active",
      "Locked": "Locked",
      "Up": "Up",
      "Down": "Down",
      "PointsDelta": "{{value}}pp"
    },
    "Devices": {
      "Title": "Devices",
      "Caption": "Every device sits in exactly one program",
      "ProgramSplit": "Devices by program",
      "ProgramBreakdown": "Program breakdown",
      "TotalDevices": "Total devices",
      "OfPortfolio": "{{value}} of portfolio",
      "SegmentLabel": "{{program}}: {{value}}"
    },
    "Programs": {
      "Financing": "Financing",
      "DeviceFinancing": "Device Financing",
      "SupplyChain": "Supply Chain",
      "Inventory": "Inventory"
    },
    "Services": {
      "Title": "Services",
      "Caption": "{{active}} active · updated {{time}}, enforcement data {{lag}} min behind",
      "Tabs": {
        "Financing": "Device Financing",
        "SupplyChain": "Supply Chain"
      },
      "BarLabel": "{{label}} {{percent}}",
      "Status": {
        "Enrolled": "Enrolled",
        "Active": "Active",
        "Locked": "Locked",
        "Released": "Released",
        "InStock": "In Stock",
        "Stolen": "Stolen",
        "Delivered": "Delivered"
      },
      "Captions": {
        "AwaitingActivation": "Awaiting activation",
        "ActiveActive": "Active · Active",
        "OnPaymentMissed": "On payment missed",
        "TermComplete": "Term complete",
        "ProtectedStock": "Protected · Stock",
        "LockedRestricted": "Locked · Restricted",
        "CompletedReleased": "Completed · Released"
      },
      "Notice": {
        "Financing": {
          "Title": "Grace pool grew 12% this week",
          "Body": "Concentrated on D17 devices in the Nairobi corridor. 213 already past their escalation timer.",
          "Action": "Review grace queue"
        },
        "SupplyChain": {
          "Title": "1,180 shipments beyond expected delivery",
          "Body": "Over 30 days without a Delivery Confirmed event - 62% concentrated on the Mombasa route.",
          "Action": "Investigate"
        }
      }
    },
    "Attention": {
      "Title": "Needs your attention",
      "Caption": "{{total}} items · ordered by value at risk",
      "Units": {
        "Devices": "Devices",
        "Enrolments": "Enrolments"
      },
      "Tags": {
        "PostPaid": "Post-paid",
        "SupplyChain": "Supply Chain",
        "Platform": "Platform"
      },
      "Items": {
        "BatchInInventory": {
          "Title": "Batch #{{batch}} sitting in Inventory",
          "Detail": "{{model}} · no published plan to register against",
          "Action": "Publish plan"
        },
        "PaymentMissed": {
          "Title": "Payment Missed, not yet Locked",
          "Detail": "{{amount}} at risk · escalation timer expired",
          "Action": "Review and lock"
        },
        "InGrace": {
          "Title": "In grace, escalation timer running",
          "Detail": "Counted Active until the timer expires",
          "Action": "View queue"
        },
        "InTransit": {
          "Title": "In transit beyond expected delivery",
          "Detail": "Over 30 days · no Delivery Confirmed event",
          "Action": "Investigate"
        },
        "ImeiFailed": {
          "Title": "IMEI validation failed",
          "Detail": "Format, duplicate or blocklist check",
          "Action": "Review IMEIs"
        }
      }
    },
    "JumpBackIn": "Jump back in",
    "Links": {
      "DeviceRegistry": {
        "Title": "Device Registry",
        "Subtitle": "Full fleet list, states & batches"
      },
      "Grace": {
        "Title": "Grace & Escalation",
        "Subtitle": "Timers running, locks pending"
      },
      "Plans": {
        "Title": "Plans",
        "Subtitle": "Build, approve and publish"
      },
      "Reports": {
        "Title": "Reports & Export",
        "Subtitle": "Portfolio CSV / PDF"
      }
    }
  },
  "Reports": {
    "Title": "Plans & Contracts"
  },
  "Language": {
    "Label": "Language",
    "En": "English",
    "Ar": "العربية"
  },
  "Table": {
    "Empty": "No results",
    "Previous": "Previous",
    "Next": "Next",
    "PageOf": "Page {{page}} of {{lastPage}} · {{total}} total",
    "Pagination": "Pagination",
    "GoToPage": "Go to page {{page}}",
    "CursorPagination": "Pagination",
    "FirstPage": "First page",
    "Loading": "Loading results"
  },
  "A11y": {
    "SkipToContent": "Skip to main content",
    "ToggleSidebar": "Toggle sidebar",
    "Settings": "Settings",
    "Notifications": "Notifications"
  },
  "Auth": {
    "Redirecting": "Redirecting to sign-in…",
    "SignedOut": {
      "Title": "You're signed out",
      "Description": "Your session has ended. Sign in again to continue.",
      "SignInAgain": "Sign in again"
    },
    "LoopDetected": {
      "Title": "Sign-in could not be completed",
      "Description": "We tried to sign you in several times without success. Please try again shortly or contact support.",
      "Recover": "Back to sign-out"
    },
    "SessionError": {
      "Title": "Your session can't be used",
      "Description": "You're signed in, but this session cannot be used right now.",
      "ProfileFailed": "Signed in, but your profile could not be loaded. Signing out and back in may help; if it persists, contact support.",
      "RedirectFailed": "Sign-in could not be started. Please try again shortly; if it persists, contact support.",
      "SignInFailed": "Sign-in was not completed ({{error}}).",
      "ConfigUnavailable": "Unable to load authentication configuration. Please try again later.",
      "SignOut": "Sign out"
    }
  },
  "Error": {
    "NotFound": {
      "Title": "Page not found",
      "Description": "The page you are looking for does not exist.",
      "BackHome": "Back to dashboard"
    },
    "Forbidden": {
      "Title": "Access denied",
      "Description": "You don't have permission to view this page.",
      "NoRole": "Your account has no role yet. Ask a Tenant Admin to assign you one.",
      "BackHome": "Back to dashboard"
    },
    "Network": "Unable to reach the server. Check your connection.",
    "Timeout": "The request timed out. Please try again.",
    "Server": "Something went wrong on our end.",
    "NotFoundError": "That item no longer exists.",
    "Unknown": "Something went wrong.",
    "Auth": "Your session has expired. Please sign in again.",
    "Canceled": "The request was canceled.",
    "Validation": "Some fields need your attention.",
    "ForbiddenError": "You don't have permission to do that.",
    "Retry": "Retry",
    "Boundary": {
      "Root": {
        "Title": "Something went wrong",
        "Description": "The application hit an unexpected error. Reloading usually fixes it."
      },
      "Route": {
        "Title": "This page failed to load",
        "Description": "Something went wrong loading this page. Navigation still works."
      },
      "Widget": {
        "Title": "This section failed to load",
        "Description": "The rest of the page is unaffected."
      },
      "Reload": "Reload page",
      "TraceId": "Reference ID: {{traceId}}"
    }
  },
  "Devices": {
    "Title": "Devices",
    "Subtitle": "Every device under management for this tenant.",
    "NotAvailable": "Not available",
    "NoState": "No policy yet",
    "NoService": "No service",
    "Services": {
      "dfpost": "DF Post-paid",
      "sc": "Supply Chain",
      "dfpre": "DF Pre-paid",
      "sim": "SIM Control"
    },
    "Actions": {
      "ExportCsv": "Export CSV",
      "Register": "Register"
    },
    "Register": {
      "Title": "Register single device",
      "Description": "Register a device by its IMEI. It appears in the registry once the service accepts it.",
      "ImeiLabel": "IMEI",
      "ImeiPlaceholder": "Enter or paste IMEI",
      "Submit": "Register device",
      "Errors": {
        "Pattern": "Enter the 15-digit IMEI, digits only."
      },
      "Failure": {
        "Luhn": {
          "Title": "This IMEI's check digit is not valid.",
          "Body": "Check the digits against the label on the device and try again."
        },
        "Duplicate": {
          "Title": "This IMEI is already registered on the platform.",
          "Body": "Search the registry to locate the existing record."
        },
        "Pattern": {
          "Title": "This IMEI was not accepted.",
          "Body": "Enter the 15-digit IMEI, digits only."
        },
        "Forbidden": {
          "Title": "You do not have permission to register devices.",
          "Body": "Ask a Tenant Admin for a role that can register devices."
        },
        "Generic": {
          "Title": "Could not register the device.",
          "Body": "Please try again."
        }
      },
      "Registered": {
        "Title": "Device registered",
        "Body": "Now searchable in the registry. Hardware details enrich at first check-in.",
        "DeviceIdLabel": "Device ID",
        "RegisterAnother": "Register another",
        "ViewDevice": "View device"
      },
      "Menu": {
        "Single": {
          "Title": "Single device",
          "Description": "Enter one device manually by IMEI"
        },
        "Bulk": {
          "Title": "Bulk upload",
          "Description": "Register many devices from a CSV file"
        }
      }
    },
    "Ago": {
      "Minutes": "{{value}}m ago",
      "Hours": "{{value}}h ago",
      "Days": "{{value}}d ago"
    },
    "When": {
      "Today": "Today {{time}}",
      "Yesterday": "Yest {{time}}",
      "On": "{{day}} {{time}}"
    },
    "Overview": {
      "Title": "Overview",
      "TotalDevices": "Total devices",
      "NeedAttention": "Need Attention",
      "Synced24h": "Synced 24h",
      "Up": "Up",
      "Down": "Down"
    },
    "Tabs": {
      "Registry": "Registry",
      "Provisioning": "Provisioning Queue",
      "Audit": "Audit log"
    },
    "Columns": {
      "Select": "Select row",
      "SelectAll": "Select all rows on this page",
      "Imei": "IMEI",
      "Service": "SERVICE",
      "Plan": "PLAN",
      "State": "STATE",
      "Whitelist": "WHITELIST",
      "Serial": "SERIAL",
      "Registered": "LAST SYNC",
      "ViewDevice": "View device {{value}}"
    },
    "Filters": {
      "All": "All",
      "Lock": "Lock",
      "Unlock": "Unlock",
      "ServiceType": "Service type",
      "Batch": "Batch",
      "SearchImei": "Search IMEI",
      "SearchPlaceholder": "Search IMEI or reference..",
      "SearchLandmark": "Search the device registry",
      "SearchSerial": "Search serial",
      "ClearSearch": "Clear search",
      "Unavailable": "Filtering by this field is not available yet"
    },
    "Bulk": {
      "Title": "Bulk actions",
      "Close": "Close bulk actions",
      "DevicesSelected": "{{value}} devices selected",
      "Scope": "Actions apply only to devices they're valid for.",
      "StateCount": "{{value}} {{state}}",
      "Available": "Available for this selection",
      "Actions": {
        "lock": "Lock",
        "unlock": "Unlock",
        "reassignPlan": "Reassign plan",
        "export": "Export selection"
      },
      "Badge": {
        "Locked": "{{value}} locked",
        "Unlocked": "{{value}} unlocked",
        "Devices": "{{value}} devices"
      },
      "Message": {
        "Label": "Enter custom message",
        "Counter": "{{value}}/{{max}}"
      },
      "Cancel": "Cancel",
      "Save": "Save changes",
      "Confirm": {
        "Title": "Are you sure these are the right actions?",
        "Body": "The action you chose will be applied to every selected device it is valid for. Devices it does not apply to are left untouched.",
        "Continue": "Yes, continue"
      }
    },
    "ShowingRange": "Showing {{from}}–{{to}} of {{total}} devices",
    "Error": {
      "Title": "Could not load devices",
      "Retry": "Try again"
    },
    "Empty": {
      "Provisioning": {
        "Title": "Provisioning Queue",
        "Body": "Devices queued for provisioning will appear here."
      },
      "Audit": {
        "Title": "Audit log",
        "Body": "Every device state change is recorded here."
      },
      "Registry": {
        "Title": "No devices",
        "Body": "No device matches this filter."
      }
    },
    "Lock": {
      "PendingHint": "A lock command is in flight. The device has not acknowledged it yet.",
      "Success": "Lock command sent. Waiting for the device to acknowledge.",
      "Errors": {
        "InFlight": "A lock command is already in flight for this device.",
        "NotFound": "This device is no longer in the registry.",
        "Forbidden": "You do not have permission to lock this device.",
        "Generic": "The lock command could not be sent. Try again."
      }
    },
    "Unlock": {
      "PendingHint": "An unlock command is in flight. The device has not acknowledged it yet.",
      "Success": "Unlock command sent. Waiting for the device to acknowledge.",
      "Errors": {
        "InFlight": "A command is already in flight for this device.",
        "NotFound": "This device is no longer in the registry.",
        "Forbidden": "You do not have permission to unlock this device.",
        "Generic": "The unlock command could not be sent. Try again."
      }
    },
    "Release": {
      "PendingHint": "A release command is in flight. The device has not acknowledged it yet."
    },
    "AssignService": {
      "Title": "Assign service",
      "Description": "Choose the service to enrol this device into.",
      "Services": {
        "dfpost": "Device Financing – Post-paid",
        "sc": "Supply Chain",
        "dfpre": "Device Financing – Pre-paid",
        "sim": "SIM Control"
      },
      "NotAvailable": "Not available yet",
      "Submit": "Assign service",
      "Success": "Service assigned.",
      "Errors": {
        "Forbidden": "You do not have permission to assign a service to this device.",
        "NotFound": "No device is registered with this IMEI.",
        "AlreadyAssigned": "This device already has a service that prevents this assignment.",
        "Generic": "The service could not be assigned. Try again."
      }
    },
    "Detail": {
      "Title": "Selected device",
      "Close": "Close device details",
      "PostpaidFinancing": "POSTPAID FINANCING",
      "CommandBadge": {
        "PendingLock": "PENDING LOCK",
        "PendingUnlock": "PENDING UNLOCK",
        "AwaitingResponse": "AWAITING DEVICE RESPONSE"
      },
      "Identifier": "IMEI {{imei}}",
      "Actions": {
        "QuickAction": "Quick Action",
        "Edit": "Edit",
        "PinUnlock": "Pin Unlock",
        "LogCase": "Log Case",
        "AssignService": "Assign Service",
        "AssignServiceNoImei": "Assigning a service needs the device's IMEI",
        "ReassignPlan": "Re-Assign Plan",
        "LockDevice": "Lock Device",
        "LockConfirm": {
          "Title": "Lock this device?",
          "Body": "A full lock takes the device out of use. It stays locked until it is unlocked.",
          "Continue": "Yes, lock device"
        },
        "UnlockDevice": "Unlock Device",
        "UnlockConfirm": {
          "Title": "Unlock this device?",
          "Body": "Unlocking returns the device to its user. It stays unlocked until it is locked again.",
          "Continue": "Yes, unlock device"
        },
        "NotAvailableYet": "This action is not available yet"
      },
      "Tabs": {
        "Summary": "Summary",
        "Device": "Device",
        "Connectivity": "Connectivity",
        "Security": "Security",
        "History": "History"
      },
      "Current": {
        "Section": "CURRENT ENROLMENT",
        "Plan": "Plan · resolves live",
        "Workflow": "Workflow",
        "Stage": "Stage",
        "Whitelist": "Whitelist",
        "Term": "Term",
        "TenantStatus": "Status supplied by tenant"
      },
      "Agent": {
        "Section": "AGENT",
        "Bundle": "Bundle",
        "LastCheckedIn": "Last Checked in",
        "Connectivity": "Connectivity",
        "ConnectivityStatus": {
          "UNPROVISIONED": "Not provisioned",
          "ONLINE": "Online",
          "OFFLINE": "Offline"
        },
        "App": "App"
      },
      "Health": {
        "Section": "DEVICE HEALTH",
        "Battery": "Battery",
        "BatteryValue": "{{value}}%",
        "Storage": "Storage used",
        "StorageValue": "{{value}}% used",
        "LastSeen": "Last seen",
        "AppVersion": "App version"
      },
      "Build": {
        "Section": "IDENTITY & BUILD",
        "ReportedModel": "Reported model",
        "Manufacturer": "Manufacturer",
        "SerialNumber": "Serial number",
        "AndroidOs": "Android OS · SDK",
        "SdkValue": "SDK {{value}}",
        "Firmware": "Firmware version",
        "Timezone": "Timezone",
        "Enrolled": "Enrolled"
      },
      "Sim": {
        "Section": "SIM",
        "Iccid": "ICCID",
        "OriginalIccid": "Original ICCID",
        "Phone": "Phone",
        "Gated": "Gated",
        "Changed": "SIM changed",
        "Reveal": "Reveal",
        "Info": {
          "Title": "Info",
          "Body": "Raw ICCID and phone number are not shipped in the device payload. Reveal calls a role-gated server endpoint and writes an audit entry."
        }
      },
      "Security": {
        "Section": "SECURITY",
        "SimSwap": "Sim Swap",
        "OfflineFailSafe": "Offline fail safe"
      },
      "Location": {
        "Section": "LOCATION",
        "Locked": "Locked",
        "Info": {
          "Title": "Info",
          "Body": "Device coordinates are not surfaced while the device is in good standing. Location unlocks for the duration of an approved recovery workflow and is retention-limited."
        }
      },
      "Enrolments": {
        "Section": "ENROLMENT HISTORY",
        "ViewMore": "View more",
        "Reference": "ENROLMENT",
        "Service": "SERVICE",
        "Plan": "PLAN",
        "Period": "PERIOD",
        "Outcome": "OUTCOME",
        "Services": {
          "POSTPAID": "DF Post-paid",
          "FINANCING": "DF Financing"
        },
        "PlanValue": "{{plan}} v{{version}}",
        "PeriodValue": "{{from}} – {{to}}",
        "Present": "present",
        "Outcomes": {
          "active": "ACTIVE",
          "delivered": "DELIVERED",
          "ended": "ENDED"
        },
        "OpenAuditLog": "Open the device audit log"
      },
      "Enrolment": {
        "Section": "ENROLMENT HISTORY",
        "When": "WHEN",
        "Origin": "ORIGIN",
        "Event": "EVENT",
        "Origins": {
          "SERVER": "Server",
          "DEVICE": "Device",
          "QUEUED": "Queued"
        },
        "QueuedValue": "Queued ({{value}})",
        "Override": "Overrode device lock ({{value}})",
        "OpenInAuditLog": "Open this event in the audit log",
        "ClearAll": "Clear all",
        "Filter": "Filter events",
        "FilterActive": "Filter events ({{value}} applied)",
        "Unavailable": "Filtering the enrolment history by event type is not available yet",
        "Kinds": {
          "all": "All",
          "enforcement": "Enforcement",
          "messages": "Messages",
          "bindings": "Bindings",
          "agents": "Agents"
        }
      },
      "Empty": {
        "Connectivity": {
          "Title": "Connectivity",
          "Body": "Network and sync details will appear here."
        }
      },
      "Batch": "Batch",
      "Loading": "Loading device details",
      "Error": {
        "Title": "Could not load this device"
      }
    },
    "BulkRegister": {
      "Title": "Bulk register devices",
      "CompleteTitle": "Registration complete",
      "DeviceFileLabel": "Device file",
      "Dropzone": {
        "Prompt": "Drop CSV here or browse",
        "Hint": "One row per device · IMEI and/or serial number",
        "AriaLabel": "Upload a CSV of devices. Drag and drop a file here, or activate to browse."
      },
      "File": {
        "Remove": "Remove file"
      },
      "Uploading": "Uploading…",
      "Processing": "Registering devices…",
      "BatchRange": "Rows {{from}}–{{to}}",
      "BatchStatus": {
        "pending": "Pending",
        "processing": "Processing",
        "succeeded": "Done",
        "failed": "Failed"
      },
      "CompleteBody": "Registered devices are now in the registry.",
      "CompleteNeedsAttention": "Some batches did not finish. Retry them to register the remaining devices.",
      "Stats": {
        "Registered": "Registered",
        "Failed": "Failed",
        "NotProcessed": "Not processed"
      },
      "Actions": {
        "Continue": "Continue",
        "DownloadResults": "Download results file",
        "ViewRegistry": "View in registry",
        "RetryFailed": "Retry failed batches",
        "DownloadTemplate": "Download template"
      },
      "Errors": {
        "mime": {
          "Title": "Not a CSV file",
          "Body": "Choose a file with a .csv extension."
        },
        "size": {
          "Title": "File is too large",
          "Body": "Choose a CSV within the size limit."
        },
        "header": {
          "Title": "Unexpected columns",
          "Body": "The header row must match the template. Download the template to check."
        },
        "file_too_large": {
          "Title": "File is too large",
          "Body": "The server rejected the file for exceeding the size limit."
        },
        "unsupported_media_type": {
          "Title": "Unsupported file type",
          "Body": "Only CSV files are accepted."
        },
        "empty_file": {
          "Title": "No data rows",
          "Body": "The CSV has a header but no device rows."
        },
        "upload": {
          "Title": "Upload failed",
          "Body": "The file could not be uploaded. Check your connection and try again."
        },
        "server": {
          "Title": "Something went wrong",
          "Body": "The registration could not be started. Try again."
        }
      }
    }
  },
  "Users": {
    "Title": "Users",
    "DisplayName": "Display name",
    "Email": "Email",
    "Status": "Status",
    "SearchPlaceholder": "Search users",
    "ClearFilters": "Clear filters",
    "EditTitle": "Edit user",
    "EditDescription": "Update this user’s details.",
    "EditFailed": "Could not save changes."
  },
  "Configuration": {
    "Title": "App customization",
    "Subline": "Personal account information and preferences. These settings apply to you only.",
    "Sections": {
      "Organisation": "Organisation · Tenant admin",
      "AppSettings": "App settings"
    },
    "UsersAndRoles": {
      "Title": "Users and roles",
      "Description": "Manage users, roles, and permissions to control who can access and manage different parts of the platform.",
      "Impact": "Affects access",
      "Subline": "Manage users, assign roles, and control access across the platform based on each role’s permissions.",
      "Tabs": {
        "RolesAndPermissions": "Roles & permissions",
        "Users": "Users"
      },
      "Users": {
        "Columns": {
          "User": "USER",
          "Email": "EMAIL",
          "Role": "ROLE",
          "Status": "STATUS",
          "LastActive": "LAST ACTIVE",
          "Actions": "Actions"
        },
        "Title": "Users",
        "ComingSoon": "This section is still being implemented and will be available soon.",
        "Summary": "{{value}} users",
        "SummaryPending": "{{value}} users · {{pending}} pending",
        "ShowingRange": "Showing {{from}}–{{to}} of {{total}} users",
        "Filters": {
          "Role": "Role",
          "Status": "Status",
          "AllRoles": "All roles",
          "AllStatuses": "All statuses",
          "SearchPlaceholder": "Search by name or email…",
          "SearchLandmark": "Search the tenant's users"
        },
        "Status": {
          "Active": "Active",
          "Pending": "Pending invite",
          "Deactivated": "Deactivated",
          "Unknown": "This status is not described yet"
        },
        "You": "(you)",
        "Roles": {
          "None": "No role assigned"
        },
        "LastActive": {
          "JustNow": "Just now",
          "Unknown": "No activity recorded",
          "NotApplicable": "Not applicable",
          "Invited": "Invited {{when}}",
          "Deactivated": "Deactivated {{when}}",
          "Expires": "expires {{when}}",
          "Expired": "expired {{when}}",
          "InvitedExpiry": "{{invited}} · {{expiry}}"
        },
        "Actions": {
          "Open": "Actions for {{name}}",
          "ChangeRole": "Change role",
          "ViewActivity": "View activity / audit log",
          "Deactivate": "Deactivate",
          "ResendInvite": "Resend invite",
          "CopyInviteLink": "Copy invite link",
          "CancelInvite": "Cancel invite",
          "Reactivate": "Reactivate",
          "RemovePermanently": "Remove permanently",
          "DeactivateConfirm": {
            "Title": "Deactivate this user?",
            "Body": "{{name}} loses access right away and stays on the list as deactivated. You can reactivate them later.",
            "Continue": "Yes, deactivate"
          },
          "ReactivateConfirm": {
            "Title": "Reactivate this user?",
            "Body": "{{name}} gets their access back with the role they had before.",
            "Continue": "Yes, reactivate"
          }
        },
        "Deactivate": {
          "Success": "{{name}} has been deactivated.",
          "Errors": {
            "Conflict": "This user is already deactivated.",
            "NotFound": "This user is no longer on the tenant.",
            "Forbidden": "You do not have permission to deactivate this user.",
            "Generic": "The user could not be deactivated. Try again."
          }
        },
        "Reactivate": {
          "Success": "{{name}} has been reactivated.",
          "Errors": {
            "Conflict": "This user is not deactivated.",
            "NotFound": "This user is no longer on the tenant.",
            "Forbidden": "You do not have permission to reactivate this user.",
            "Generic": "The user could not be reactivated. Try again."
          }
        }
      },
      "Columns": {
        "Role": "ROLE",
        "CanDo": "CAN DO",
        "Affects": "AFFECTS",
        "Users": "USERS"
      },
      "Affects": {
        "PlatformWide": "Platform-wide",
        "TenantWide": "Tenant-wide",
        "LinkDevices": "Link devices",
        "EveryDevice": "Every device",
        "OneDevice": "One device"
      },
      "Error": {
        "Title": "Users could not be loaded",
        "RolesTitle": "Roles could not be loaded",
        "Retry": "Try again"
      },
      "UnknownRole": "This role is not described yet",
      "SummaryMissing": "This role carries no description",
      "AffectsMissing": "This role’s reach is not stated",
      "RoleUsers": {
        "None": "No users hold this role",
        "More": "+{{more}}"
      },
      "Roles": {
        "SuperAdmin": {
          "Name": "Super Admin",
          "CanDo": "Every tenant, every setting, every user"
        },
        "InternalDataLoader": {
          "Name": "Internal Data Loader",
          "CanDo": "Bulk device and plan data loads across tenants"
        },
        "TenantAdmin": {
          "Name": "Tenant Admin",
          "CanDo": "Settings, users, integrations"
        },
        "Operations": {
          "Name": "Operations",
          "CanDo": "Device actions, plans, workflows"
        },
        "Provisioning": {
          "Name": "Provisioning",
          "CanDo": "Enrolment, linking, device onboarding"
        },
        "Finance": {
          "Name": "Finance",
          "CanDo": "Plans, pricing, billing records"
        },
        "Support": {
          "Name": "Support",
          "CanDo": "Cases, unlock codes, device lookups"
        },
        "Viewer": {
          "Name": "Viewer",
          "CanDo": "Read only"
        },
        "ReleaseAuthority": {
          "Name": "Release Authority",
          "CanDo": "Releases devices from the plan holding them"
        }
      },
      "Notice": {
        "Title": "No mandatory approval gates",
        "Body": "Permitted actions execute on the user’s own authority and are attributed in full. Review is requested by the originator when they want it.",
        "Emphasis": "Changing device state is a distinct permission from editing plans and workflows."
      },
      "Invite": {
        "Trigger": "Invite user",
        "Title": "Invite user",
        "NameLabel": "Name",
        "NamePlaceholder": "Enter name",
        "EmailLabel": "Email",
        "EmailPlaceholder": "Enter email",
        "RoleLabel": "Role",
        "RolePlaceholder": "Select role",
        "Counter": "{{current}}/{{max}}",
        "Submit": "Invite user",
        "Errors": {
          "NameRequired": "Enter a name.",
          "EmailInvalid": "Enter a valid email address.",
          "Duplicate": "A user with this email address already exists.",
          "Forbidden": "You do not have permission to invite users.",
          "Generic": "The invitation could not be sent. Try again."
        },
        "Success": "{{name}} has been invited."
      }
    },
    "ApiAndWebhooks": {
      "Impact": "Affects integrations",
      "CardTitle": "API and webhooks",
      "Description": "Configure API access and webhooks to connect external systems and automate data exchange.",
      "Title": "API and Webhooks",
      "ReadOnly": "Read only",
      "Subline": "Endpoints the platform sends signed state-change events to. Test an endpoint to confirm it receives them.",
      "Inbound": {
        "Title": "Payment events · Inbound",
        "NoteTitle": "Platform events",
        "NoteBody": "Your systems raise Payment Missed and Payment Received.",
        "NoteEmphasis": "The platform never infers payment status and acts on nothing else."
      },
      "Endpoints": "Endpoints",
      "Entitled": "Events entitled",
      "Columns": {
        "Endpoint": "Endpoints",
        "Events": "Events",
        "Health": "Health",
        "Actions": "Actions"
      },
      "Health": {
        "Rate": "{{rate}} · 24h",
        "Failed": "{{failed}} failed",
        "NoDeliveries": "No deliveries · 24h"
      },
      "Actions": {
        "SendTest": "Send test event",
        "SendTestFor": "Send test event to {{endpoint}}",
        "View": "View",
        "ViewFor": "View {{endpoint}}"
      },
      "Test": {
        "Delivered": "Test event delivered",
        "DeliveredDetail": "HTTP {{status}} in {{duration}}",
        "Failed": "Test event failed",
        "NoResponse": "No response",
        "Error": "The test event could not be sent. Try again."
      },
      "Detail": {
        "Title": "Endpoint details",
        "Description": "Read only. Endpoints are configured for your tenant by Cenorion.",
        "Url": "Endpoint URL",
        "Secret": "Signing secret",
        "Events": "Events"
      }
    },
    "Customisation": {
      "Title": "Application Customisation",
      "Description": "Customize how the consumer app appears on devices, including logos, colors, and other brand settings.",
      "Impact": "Affects every device",
      "Subline": "How the consumer application appears on device.",
      "SublineCheckIn": "Changes reach live devices at next check-in.",
      "Discard": "Discard changes",
      "Save": "Save",
      "SectionsLabel": "Customisation sections",
      "Tabs": {
        "DisplayName": "Display name",
        "Logo": "Logo",
        "Palette": "Colour palette",
        "Currency": "Currency Symbol",
        "Typography": "Typography",
        "Theme": "Theme",
        "Appearance": "Appearance"
      },
      "DisplayName": {
        "Title": "Display name",
        "Description": "Shown to holders on the lock screen and in-app messages. Keep it recognisable — this is what identifies you as their financier.",
        "Counter": "{{length}} / {{max}} characters",
        "TooLong": "Display name must be {{max}} characters or fewer.",
        "Required": "Enter a display name."
      },
      "Logo": {
        "Title": "Logo",
        "Rules": "PNG or SVG, square, min 256×256, max 1 MB.",
        "Full": "Full logo",
        "Icon": "Logo icon",
        "Upload": "Drop a file here or click to browse",
        "UploadLabel": "Upload {{label}}",
        "ReplaceLabel": "Replace {{label}}",
        "Remove": "Remove",
        "Replace": "Replace",
        "Errors": {
          "Type": "Upload a PNG or SVG file.",
          "Size": "The file is larger than 1 MB.",
          "Unreadable": "The image size could not be read. Try another file.",
          "NotSquare": "The logo must be square.",
          "TooSmall": "The logo must be at least 256×256."
        },
        "IconRequired": "Upload a logo icon. Devices show it wherever the brand appears."
      },
      "Palette": {
        "Title": "Colour palette",
        "Description": "Applied to buttons, headers and accents in the Onari app.",
        "Hex": "{{label}} hex code",
        "UsedFor": "Used for",
        "Roles": {
          "primary": "Primary",
          "secondary": "Secondary",
          "accent": "Accent",
          "surface": "Surface"
        },
        "Usage": {
          "PrimaryButtons": "Primary buttons",
          "Links": "Links",
          "ActiveStates": "Active states",
          "LockScreen": "Lock screen background",
          "Headers": "Headers",
          "StrongText": "Strong text/icons",
          "Highlights": "Highlights",
          "ProgressBars": "Progress bars",
          "Badges": "Badges & warnings",
          "AppBackground": "App background",
          "Cards": "Cards",
          "InputFields": "Input fields"
        }
      },
      "Currency": {
        "Title": "Currency symbol",
        "Description": "Shown against payment amounts in the app. Symbol only — full number/locale formatting stays out of V1.",
        "Currency": "Currency",
        "Symbol": "Symbol"
      },
      "Typography": {
        "Title": "Typography",
        "Description": "Upload a custom font or use the system default. System default is recommended — it renders reliably across every device.",
        "System": "System default",
        "Google": "Google Fonts",
        "Custom": "Custom font",
        "SearchLabel": "Search Google Fonts",
        "SearchPlaceholder": "Search google fonts here..",
        "ClearSearch": "Clear search",
        "NoMatches": "No fonts match your search.",
        "ChangeFont": "Change font",
        "Upload": "Upload custom font",
        "UploadLabel": "Upload custom font",
        "UploadHint": "Drag and drop your font file here, or upload from your device.",
        "UploadButton": "Upload font",
        "Rules": ".TTF, .OTF · Max 10MB",
        "Errors": {
          "Type": "Upload a .ttf or .otf font file.",
          "Size": "The file is larger than 10 MB."
        }
      },
      "Theme": {
        "Title": "Custom Themes",
        "Description": "How your brand color gets applied across the app. Each preset guarantees accessible contrast; pick the one that best matches your brand voice.",
        "Continue": "Continue",
        "Presets": {
          "signature": {
            "Title": "Signature",
            "Description": "Logo,\nNeutral CTAs.\nSafest with any palette."
          },
          "branded": {
            "Title": "Branded",
            "Description": "Brand drives primary\nCTAs. Auto-checks\ncontrast."
          },
          "duotone": {
            "Title": "Duotone",
            "Description": "Primary for CTAs,\nSecondary for headers."
          }
        }
      },
      "Appearance": {
        "Title": "Appearance",
        "Description": "Whether the app follows the holder's system setting, or is locked to light or dark. Most tenants leave this on System.",
        "Light": "Light",
        "Dark": "Dark",
        "System": "System"
      },
      "Preview": {
        "Logo": "Logo preview",
        "Typography": "Typography preview",
        "Button": "Button preview",
        "Accent": "Accent preview",
        "Greeting": "Good morning,",
        "HolderName": "Amara K.",
        "MakePayment": "Make a payment",
        "AccentCard": "Your next payment is due soon"
      },
      "Load": {
        "Loading": "Loading branding",
        "Error": "Branding could not be loaded",
        "Retry": "Try again"
      },
      "Publish": {
        "Success": "Branding published. Devices pick it up on their next check-in.",
        "Errors": {
          "Invalid": "A logo was rejected. Check it is a valid PNG or SVG, square, 256 to 2048 px, and not animated.",
          "Forbidden": "You don't have permission to change branding.",
          "Generic": "Branding could not be published. Please try again."
        }
      },
      "Confirm": {
        "Discard": {
          "Title": "Discard your changes?",
          "Body": "Every edit since the last save will be lost. This cannot be undone.",
          "Continue": "Discard changes"
        },
        "Publish": {
          "Title": "Publish branding to devices?",
          "Body": "Every device under your tenant picks up the new branding on its next check-in.",
          "Continue": "Publish"
        }
      }
    },
    "Whitelists": {
      "Title": "Whitelist Restrictions - Applications & Calls",
      "Description": "Define device access during enforcement, including emergency and unlock options.",
      "Impact": "Affects enforcement",
      "Subline": "Named lists of what stays reachable while a device is locked, plus policy for emergency dialling, offline behaviour and unlock codes.",
      "New": "New whitelist",
      "ShowingRange": "Showing {{from}}–{{to}} of {{total}}",
      "Columns": {
        "List": "List",
        "Allows": "Allows",
        "UsedIn": "Used in",
        "LockedNow": "Locked now",
        "Actions": "Actions"
      },
      "Actions": {
        "Edit": "Edit",
        "Duplicate": "Duplicate",
        "ViewFor": "View {{name}}",
        "EditFor": "Edit {{name}}",
        "DuplicateFor": "Duplicate {{name}}"
      },
      "Detail": {
        "NotApplied": "Not applied to any workflow yet.",
        "Rename": "Rename whitelist",
        "Applications": "Applications reachable while locked",
        "PhoneNumbers": "Phone numbers reachable while locked",
        "AddApplication": "Add application",
        "AddPhoneNumber": "Add phone number",
        "Fixed": "Fixed",
        "Remove": "Remove",
        "RemoveFor": "Remove {{name}}",
        "ImpactTitle": "Impact of saving",
        "ImpactBody": "{{devices}} devices currently locked under this profile will pick up the change at next check-in. {{workflows}} workflows reference this whitelist; the reference stays intact."
      },
      "NotTracked": "Not tracked yet",
      "Error": {
        "Title": "Whitelists could not be loaded",
        "Retry": "Try again"
      }
    }
  }
}
